import React, { useState } from 'react';

const ExpandableParagraph = ({ text, maxLength = 100 }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const renderText = () => {
        if (isExpanded) {
            return text;
        }
        return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    };

    return (
        <div>
            <p dangerouslySetInnerHTML={{ __html: renderText() }}></p>
            {text.length > maxLength && (
                <button onClick={toggleExpand}>
                    {isExpanded ? 'View Less' : 'View More'}
                </button>
            )}
        </div>
    );
};

export default ExpandableParagraph;
